module.exports = __webpack_public_path__ + "static/media/bg4.1decfb0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg4.jpg
// module id = 5789
// module chunks = 0